import Axios from 'axios';

const axiosInstance = Axios.create({});

export default axiosInstance;
